(ns manage.ad-variant.creation.ad-builder.hooks
  (:require [manage.ad-variant.data :as d]))

(defn preserve-ad-format
  "Preserves an ad-format that should remain unchanged during ad-builder updates.

   When modifying ad-formats (adding, updating, or deleting others), the backend
   loses template references for unchanged ad-formats, causing them to return empty
   values. This function explicitly sets the template-revision-id from the current
   revision to maintain the reference and prevent data loss.

   Call this for ad-formats you are NOT modifying in the current operation."
  [ad-format]
  (let [current-revision-id (get-in ad-format [:current-revision :id])]
    (-> ad-format
        (assoc :template-revision-id current-revision-id)
        (dissoc :latest-revision :current-revision))))

(defn update-template-revision [ad-format]
  (let [latest-revision-id (get-in ad-format [:latest-revision :id])]
    (-> ad-format
        (assoc :template-revision-id latest-revision-id)
        (dissoc :latest-revision :current-revision :width :height))))

(defn ->add-ad-builder-payload
  ([ad-type template] (->add-ad-builder-payload ad-type template nil))
  ([ad-type template urn-override]
   {:adBuilders [{:urn (or urn-override (:ad-builder-urn (d/ad-types ad-type)))
                  :name (:name template)
                  :ad-formats [{:template-type (get-in template [:latestRevision :templateType])
                                :width (get-in template [:latestRevision :width])
                                :height (get-in template [:latestRevision :height])
                                :template-revision-id (get-in template [:latestRevision :id])}]}]
    :operation "add"}))

(defn ->update-ad-builder-payload [ad-builder]
  {:adBuilders [(-> ad-builder
                    (update :ad-formats #(map preserve-ad-format %))
                    (dissoc :updated-at))]
   :operation "update"})

(defn ->update-template-revisions-payload [ad-builders]
  (mapv (fn [ad-builder]
          (-> (select-keys ad-builder [:id :ad-formats])
              (update-in [:ad-formats 0] update-template-revision)))
        ad-builders))

(defn ->update-ad-builder-template-payload [ad-builder template]
  {:adBuilders [(-> ad-builder
                    (assoc :name (:name template))
                    (assoc :ad-formats [{:template-type (get-in template [:latestRevision :templateType])
                                         :width (get-in template [:latestRevision :width])
                                         :height (get-in template [:latestRevision :height])
                                         :template-revision-id (get-in template [:latestRevision :id])}])
                    (dissoc :updated-at))]
   :operation "update"})
